import React from 'react';
import { useSelector } from 'react-redux';
import { AgCharts } from 'ag-charts-react';
import 'ag-charts-enterprise';
import moment from 'moment';

const AverageNetChart = () => {
    const { productSales } = useSelector(state => state.reports || {});
    let data = productSales.houlysales;
    data.sort((a, b) => a.date - b.date)

    data = data.map(item => ({
        averageTransaction: item.averageTransaction,
        branchId: item.branchId,
        branchName: item.branchName,
        datetime: new Date(item.date),
        dateformatted: moment(item.date).format("YYYY-MM-DD hhA"),
        hour: item.hour,
        netInvoicesSold: item.netInvoicesSold,
        netSales: item.netSales
    }))

    const renderer = (params) => {
        return (
            `<div class="ag-chart-tooltip-custom"><b class="title">${params.datum.dateformatted}</b><br/><b>Net Sales: ${params.datum.netSales}</b></div>`
        );
    };

    const chartOptions = {
        data: data,
        title: {
            text: "Average Transaction Amount",
          },
        series: [
            {
                type: "bar",
                xKey: "datetime",
                yKey: "averageTransaction",
                yName: "Average Net Trnansactions",
                interpolation: { type: "smooth" },
                tooltip: { renderer },
                stroke:   '#7a60e5',
                marker: {
                    enabled: true,            // Enable the markers (dots)
                    size: 5,                  // Set the size of the dot
                    shape: 'circle',          // Set the shape of the dot ('circle', 'square', etc.)
                    fill: '#f8f9fa',              // Dot color
                    stroke: '#7a60e5',          // Border color of the dot
                    strokeWidth: 1            // Border width of the dot
                },
            },
        ],
        axes: [
            {
            type: 'time',  // X-axis is a category axis for the date
            position: 'bottom',
            label: {
                formatter: ({ value }) => `${moment(value).format("MM-DD hhA")}`,
            },
            gridLine: {
                enabled: true,
            },
            interval: {
                step: 1,
            },
            title: {
                text: "Time",
            },
            crosshair: {
                snap: false,
                label: {
                    enabled: false,
                },
            },
            },
            {
            type: 'number',
            position: 'left',
            keys: ["averageTransaction"],
            label: {
                formatter: ({ value }) => `$${value}`,
            },
            gridLine: {
                enabled: true,
            },
            title: {
                text: "Average Transaction Amount",
            },
            crosshair: {
                snap: false,
                label: {
                    enabled: false,
                },
            },
            },
        ],
        background: {
            fill: '#f8f9fa', // Set background color here
        },
    };
    return(
        <React.Fragment>
            <div style={{ height: 350 }}>
                <AgCharts options={chartOptions} style={{ height: 350 }}/>
            </div>
        </React.Fragment>
    )
};
export default AverageNetChart;